export const RESET = 'EXCMCASETYPE_UPDATE_RESET'
export const SET_ERROR = 'EXCMCASETYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMCASETYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMCASETYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMCASETYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMCASETYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMCASETYPE_UPDATE_UPDATE_RETRIEVED'
